import { useEffect } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import { ReactComponent as CloseIcon } from 'src/assets/close-icon.svg';
import { authSignOut, setLicenseExpired } from 'src/redux/slices/auth';
import { useDispatch } from 'src/redux/store';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

const LicenseExpiry = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  
  const onClick = () => {  
    dispatch(setLicenseExpired({ isLicenseExpired : false }));
    dispatch(authSignOut());
  };

  return (
    <Dialog
      open={true}
      fullWidth
      disableEscapeKeyDown
    >
      <DialogTitle>
        <Typography fontSize={'26px'} fontWeight={500}>
        {t(T.licenseExpired)}
        </Typography>
      </DialogTitle>
      <IconButton
        onClick={onClick}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Box>{t(T.licenseExpiredMessage)}</Box>
      </DialogContent>
    </Dialog>
  );
};
export default LicenseExpiry;
